export const signUpFlowSelectorName = 'signUpFlow';
